// extracted by mini-css-extract-plugin
module.exports = {"rootTouchBuffer":"Handle_rootTouchBuffer__2Ckgf","visibleHandle":"Handle_visibleHandle__pXYzC","dragged":"Handle_dragged__1a8t-"};